import * as React from 'react';

import { cn } from '@heidi/utils';

import { useIsExperimentalDesignSystemForms } from '../hooks/use-is-experimental-design-system-forms';
import {
  inputVariantsExperimental,
  wrapperDisabledClassesExperimental,
  wrapperVariantsExperimental,
} from './input.experimental.styles';
import {
  inputAutofillClasses,
  inputVariants,
  wrapperDisabledClasses,
  wrapperVariants,
} from './input.styles';
import type { InputProps } from './input.types';

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      accessoryStart,
      accessoryEnd,
      className,
      wrapperClassName,
      type,
      disabled,
      density = 'comfortable',
      ...props
    },
    ref
  ) => {
    const isExperimentalForms = useIsExperimentalDesignSystemForms();
    const resolvedWrapperVariants = isExperimentalForms
      ? wrapperVariantsExperimental
      : wrapperVariants;
    const resolvedWrapperDisabled = isExperimentalForms
      ? wrapperDisabledClassesExperimental
      : wrapperDisabledClasses;
    const resolvedInputVariants = isExperimentalForms
      ? inputVariantsExperimental
      : inputVariants;

    return (
      <div
        data-density={density}
        data-experimental={isExperimentalForms || undefined}
        className={cn(
          resolvedWrapperVariants({ density }),
          disabled && resolvedWrapperDisabled,
          wrapperClassName
        )}
      >
        {accessoryStart}
        <input
          type={type}
          data-density={density}
          className={cn(
            resolvedInputVariants({ density }),
            inputAutofillClasses,
            className
          )}
          ref={ref}
          disabled={disabled}
          {...props}
        />
        {accessoryEnd}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
